import { render, staticRenderFns } from "./statusDetail.vue?vue&type=template&id=bf0aaa48&scoped=true&"
import script from "./statusDetail.vue?vue&type=script&lang=js&"
export * from "./statusDetail.vue?vue&type=script&lang=js&"
import style0 from "./statusDetail.vue?vue&type=style&index=0&id=bf0aaa48&lang=less&scoped=true&"
import style1 from "./statusDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0aaa48",
  null
  
)

export default component.exports